// ErrorContext.tsx

import React, { createContext, useContext, useState, ReactNode } from "react";

// Define the shape of your error context data
interface ErrorContextData {
  error: string | null;
  showErrorModal: (message: string) => void;
  clearErrorModal: () => void;
}

// Create the ErrorContext
const ErrorContext = createContext<ErrorContextData | undefined>(undefined);

interface ErrorProviderProps {
  children: ReactNode;
}

export const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
  const [error, setError] = useState<string | null>(null);

  const showErrorModal = (message: string) => {
    setError(message);
  };

  const clearErrorModal = () => {
    setError(null);
  };

  return (
    <ErrorContext.Provider value={{ error, showErrorModal, clearErrorModal }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = (): ErrorContextData => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error("useError must be used within an ErrorProvider");
  }
  return context;
};
